export const API_STATUS_MASTER = "API_STATUS_MASTER";
export const CLEAR_API_STATUS = "CLEAR_API_STATUS";

export const SET_ADMIN_APPROVAL_CONFIG = "SET_ADMIN_APPROVAL_CONFIG";

export const SET_DRUG_TYPES = "SET_DRUG_TYPES";
export const ADD_DRUG_TYPE = "ADD_DRUG_TYPE";
export const UPDATE_DRUG_TYPE_APPROVAL = "UPDATE_DRUG_TYPE_APPROVAL";
